import { routerPostCall } from '../../axios';

const confirmInfo = (state, params) => {
  const url = `/auth/signup`;
  return routerPostCall(state, url, params);
};
export default { confirmInfo };
